export default "__VITE_ASSET__acef3a4c__"